import { Helmet } from 'react-helmet-async'
import Search from '../../common/components/listControl/search/Search'
import { Modal } from '../../common/components/modal/Modal'
import { instructions } from '../../common/utils/constants'
import { InstructionItem } from './components/instructionItem/InstructionItem'
import { ScreenModalContent } from './components/screenModalContent/ScreenModalContent'
import { useInfo } from './hooks/useInfo'
import classes from './Info.module.sass'

export const Info = () => {
  const { modalActive, setModalActive, image, showScreenModal, setSearch, clearSearch, search } =
    useInfo()

  return (
    <div className={classes.Container}>

     <Helmet>
        <title>{`logid - информация и инструкции`}</title>
        <meta
          name="description"
          content={`Информация и инструкции по работе с сервисом logid. Как разместить или найти транспорт перевозчика, грузы и загрузку для транспорта или слоты для курьеров`}
        />
      </Helmet>

      <div className={classes.Header}>Инструкции</div>
      <div className={classes.SearchContainer}>
        <Search onChange={setSearch} clear={clearSearch} placeHolder="" value={search} />
      </div>
      {instructions.filter((el) =>
        (el.title + el.description).toLowerCase().includes(search.toLowerCase()),
      ).length > 0 ? (
        <div className={classes.ListContainer}>
          {instructions
            .filter((el) =>
              (el.title + el.description).toLowerCase().includes(search.toLowerCase()),
            )
            .map((el) => (
              <InstructionItem key={el.id} item={el} showScreenModal={showScreenModal} />
            ))}
        </div>
      ) : (
        <div className={classes.Message}>Инструкции не найдены</div>
      )}
      <Modal modalActive={modalActive} setModalActive={setModalActive} image>
        <ScreenModalContent image={image} />
      </Modal>
    </div>
  )
}
